import React, { useState, useEffect } from 'react'; // Import useEffect
import { NavLink, useLocation } from 'react-router-dom';
import LogoutButton from './LogoutButton';

const PopupMessage = ({ message, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-4">
        <p>{message}</p>
        <button onClick={onClose} className="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" style={{ backgroundColor: '#0D2329' }}>
          Close
        </button>
      </div>
    </div>
  );
}

const Navbar = () => {
  const [activePage, setActivePage] = useState('');
  const location = useLocation();
  const [message, setMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    setActivePage(location.pathname);
  }, [location]);

  const handleClosePopup = () => {
    setShowPopup(false);
    setMessage('');
  };

  return (
    <>
      <nav className="w-full mx-auto px-4 sm:flex sm:items-center sm:justify-between bg-headergreen" aria-label="Global">
        <NavLink to="/frontpage">
          <img 
            src='/wvlogo.svg' 
            alt='logo' 
            style={{ height: '80px', width: 'auto' }} 
          />
        </NavLink>
        <div className="flex flex-row items-center gap-5 mt-5 sm:justify-end sm:mt-0 sm:ps-5">
          <NavLink 
            to="/profile" 
            className={`${
              activePage === '/profile' ? 'bg-pacificgreen text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'
            } rounded-md px-3 py-2 text-sm font-medium`}
          >
            PROFILE
          </NavLink>
          <NavLink 
            to="/preferences"
            className={`${
              activePage === '/preferences' ? 'bg-pacificgreen text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'
            } rounded-md px-3 py-2 text-sm font-medium`}
          >
            PREFERENCES
          </NavLink>
          <NavLink 
            to="/chats"
            className={`${
              activePage === '/chats' ? 'bg-pacificgreen text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'
            } rounded-md px-3 py-2 text-sm font-medium`}
          >
            CHATS
          </NavLink>
          <LogoutButton />
        </div>
      </nav>
      {showPopup && <PopupMessage message={message} onClose={handleClosePopup} />}
    </>
  );
}

export default Navbar;
